import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {NavLink} from 'react-router-dom';
import {withRouter} from 'react-router';

const CollectionsMenuItem = ({ clang, title, id, match: {url} }) => {
    return (
        <li className="collections__menu-list__item">
            <NavLink
                exact
                to={id !== 1945 && id !== 1977 ? `/collections/about/${id}` : `/collections/about/`}
                title={title.rendered}
                className="collections__menu-list__item--btn">
                {title.rendered}
                <span className="collections__menu-list__item--img"></span>
            </NavLink>
        </li>
    );
};

CollectionsMenuItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(CollectionsMenuItem));



// WEBPACK FOOTER //
// ./src/components/collections/CollectionsMenuItem.js